import { http, normalizePage } from '@shared/api';
import type { Page } from '@shared/api';
import type { AuditEntry, AuditFilters } from './types';

function toSearchParams(filters: AuditFilters): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: filters.page ?? 0,
    size: filters.size ?? 20,
  };
  if (filters.action) params.action = filters.action;
  if (filters.actor) params.actor = filters.actor;
  if (filters.targetType) params.targetType = filters.targetType;
  if (filters.targetId) params.targetId = filters.targetId;
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;
  return params;
}

function toExportParams(
  filters: Omit<AuditFilters, 'page' | 'size'>,
): Record<string, string | number> {
  const params: Record<string, string | number> = {};
  if (filters.action) params.action = filters.action;
  if (filters.actor) params.actor = filters.actor;
  if (filters.targetType) params.targetType = filters.targetType;
  if (filters.targetId) params.targetId = filters.targetId;
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;
  return params;
}

export const auditApi = {
  list: async (filters: AuditFilters): Promise<Page<AuditEntry>> => {
    const raw = await http.get('audit', { searchParams: toSearchParams(filters) }).json<unknown>();
    return normalizePage<AuditEntry>(raw);
  },

  exportCsv: async (filters: Omit<AuditFilters, 'page' | 'size'>): Promise<Blob> =>
    http
      .get('audit/export.csv', { searchParams: toExportParams(filters), timeout: 120_000 })
      .blob(),
};
